import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

import Config from '../../../../Config';
import ProductDescription from '../partials/ProductDescription/ProductDescription';
import Questions from '../partials/Questions/Questions';
import Linkes from '../partials/Linkes/Linkes';

function ProductPage({detailsProdact, context, openInstallationGuide}) {

    if(detailsProdact === null) return null;

    return (
        <div>
          <ProductDescription context={context} detailsProdact={detailsProdact} openInstallationGuide={openInstallationGuide}></ProductDescription>
          <div className='equipments-hr'></div>
          <Linkes context={context} pageType="product" detailsProdact={detailsProdact}></Linkes>
          <div className='equipments-hr'></div>
          <Questions context={context}></Questions>
        </div>
    );
}

const mapStateToProps = (state) => ({
    epiData: state.equipmentListPage.epiData
});

export default connect(mapStateToProps)(ProductPage);
